import { useState, useRef, useEffect, useCallback, useContext } from "react";
import UserProfileMenuArrow from "../../assets/icons/userProfileMenuArrow.svg";
import logo from "../../assets/images/nexusLogo.png";
import logoInverse from "../../assets/images/GradientNEXUS_inverse.svg";
import gradientSmall from "../../assets/images/gradiantSmall.svg";
import gradientSmallInverse from "../../assets/images/Gradient_G_inverse.svg";
import UserProfile from "../UserProfile";
import ManageDropdown from "../ManageDropdown";
import Icon from "../../assets/icons/Icon";
import useFleetStore from "../../utils/store";
import { getAllFleets } from "../../lib/api";
import { useLocation, useNavigate } from "react-router-dom";
import CustomerUserNavBar from "../CustomerUserNavBar";
import GradientAdminNavBar from "../GradientAdminNavBar";
import ZoneDropdown from "../Common/ZoneDropdown";
import CurrentUserContext from "../../contexts/CurrentUserContext";
import { blockedCustomerRoutes } from "../../utils/licenseAccess";

export default function Header({ hideNav = false }) {
  const { currentUser } = useContext(CurrentUserContext);
  const { allPodData, setAllPodData, selectedFleet, setSelectedFleet } = useFleetStore();
  const [showProfileDropdown, setShowProfileDropdown] = useState(false);
  const [showFleetDropdown, setShowFleetDropdown] = useState(false);
  const [selectedItem, setSelectedItem] = useState(null);
  const dropdownFleetRef = useRef(null);
  const location = useLocation();
  const navigate = useNavigate();
  const handleProfileDropdown = () => {
    setShowProfileDropdown(true);
  };
  const handleLogoClick = hideNav ? undefined : () => navigate("/");
  const isZoneRoute = !hideNav && currentUser?.userType === "Customer" && (
    location.pathname === '/units' ||
    location.pathname === "/alerts" ||
    location.pathname === "/dashboard"  ||
    location.pathname === "/control" ||
    location.pathname === "/energy"||
    location.pathname === "/"
  );
  const shouldShowManageDropdown =
    !hideNav &&
    currentUser?.userType === "Customer" &&
    location.pathname !== blockedCustomerRoutes.notice &&
    location.pathname !== blockedCustomerRoutes.inactive;



  const handleFleetDropdown = () => {
    setShowFleetDropdown((prev) => !prev);
  };

  const fetchAllPods = useCallback(async () => {
    const payload = { pageNumber: 1, pageSize: 100 };
    try {
      const res = await getAllFleets(payload);
      const zones = res?.data?.zones || [];
      setAllPodData(res?.data);

      if (!selectedFleet && zones.length > 0) {
        setSelectedFleet(zones[0]);
      }
    } catch (err) {
      console.error("Failed to fetch fleets", err);
    }
  }, [setAllPodData, setSelectedFleet, selectedFleet]);

  useEffect(() => {
    if (isZoneRoute) {
      fetchAllPods();
    }
  }, [fetchAllPods, isZoneRoute]);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        dropdownFleetRef.current &&
        !dropdownFleetRef.current.contains(event.target)
      ) {
        setShowFleetDropdown(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  return (
    <>
      <header className="flex flex-col gap-3 headerWrapper px-6 py-3 lg:py-0 sticky top-0 z-[100] bg-white dark:bg-[#012359] shadow-headerShadow dark:shadow-headerDarkThemeShadow h-toolbar">
        <div className="headerItems flex  items-center flex-nowrap *:shrink  justify-between  gap-6 h-full">
          <div className="logoHolder basis-auto sm:basis-1/3">
            <div className="flex items-stretch gap-4 lg:gap-6">
              <div aria-current="page" className={`active shrink-0 ${hideNav ? "" : "cursor-pointer"}`}>
                <img
                  src={logo}
                  alt="headerLogo"
                  className="hidden dark:hidden xl:flex w-24 h-auto"
                  onClick={handleLogoClick}
                />
                <img
                  src={logoInverse}
                  alt="headerLogo"
                  className="dark:xl:flex hidden w-24 h-auto"
                  onClick={handleLogoClick}
                />
                <img
                  src={gradientSmall}
                  alt="headerLogo"
                  className="flex dark:hidden xl:hidden w-8"
                  onClick={handleLogoClick}
                />
                <img
                  src={gradientSmallInverse}
                  alt="headerLogo"
                  className="dark:xl:hidden hidden dark:flex w-8"
                  onClick={handleLogoClick}
                />
              </div>


              {isZoneRoute &&
                (<>
                  <div className="pipeline w-[1px] bg-[#00000029] dark:bg-[#AFC3BCCC] shrink-0"></div>
                { allPodData?.zones?.length > 0 && <ZoneDropdown
                    fleets={allPodData?.zones}
                    selectedFleet={selectedFleet}
                    onSelect={setSelectedFleet}
                    show={showFleetDropdown}
                    toggle={handleFleetDropdown}
                    dropdownRef={dropdownFleetRef}
                  />}
                </>)}
            </div>
          </div>
          {isZoneRoute &&  <CustomerUserNavBar />}
          {!hideNav && currentUser?.userType === "GradientAdmin" &&  <GradientAdminNavBar />}
          {!hideNav && (
            <div className="headerOptions basis-1/3 flex items-center relative justify-end">
              <div className="flex gap-4 lg:gap-6 items-stretch">
                {shouldShowManageDropdown && <ManageDropdown />}
                <div className="searchIconForMinscreen flex self-center sm:flex md:hidden cursor-pointer">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="20"
                    height="20"
                    viewBox="0 0 20 20"
                    fill="none"
                  >
                    <path
                      d="M9.58366 17.4998C13.9559 17.4998 17.5003 13.9554 17.5003 9.58317C17.5003 5.21092 13.9559 1.6665 9.58366 1.6665C5.2114 1.6665 1.66699 5.21092 1.66699 9.58317C1.66699 13.9554 5.2114 17.4998 9.58366 17.4998Z"
                      stroke="#717375"
                      strokeWidth="1.5"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    ></path>
                    <path
                      d="M18.3337 18.3332L16.667 16.6665"
                      stroke="#717375"
                      strokeWidth="1.5"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    ></path>
                  </svg>
                </div>
                <div className="divider w-[1px] bg-[#C2CED7] !hidden md:flex"></div>
                <div
                  data-testid="user-profile-trigger"
                  className="userProfile cursor-pointer flex group"
                  onClick={handleProfileDropdown}
                >
                  <div className="flex gap-2 items-center">
                    <div className="userPicture size-9 dark:rounded-full flex justify-center items-center">
                      <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32" fill="none" className="*:dark:stroke-white">
                        <circle cx="16" cy="12" r="4" stroke="#1E2A2C" stroke-width="1.5"/>
                        <circle cx="16.0001" cy="15.9993" r="13.3333" stroke="#1E2A2C" stroke-width="1.5"/>
                        <path d="M23.9589 26.6667C23.7467 22.8113 22.5663 20 15.9999 20C9.43361 20 8.25321 22.8113 8.04102 26.6667" stroke="#1E2A2C" stroke-width="1.5" stroke-linecap="round"/>
                      </svg>
                      <p className="userName text-primaryText text-base font-medium leading-6 tracking-[0.15px] hidden">User Name</p>
                    </div>

                    <div className="userProfileMenuArrow hidden md:hidden">
                      <Icon
                        src={UserProfileMenuArrow}
                        alt="ArrowDown"
                        className="w-2.5 h-1.5"
                      />
                    </div>
                  </div>
                </div>
                {showProfileDropdown && (
                  <UserProfile
                    setShowProfileDropdown={setShowProfileDropdown}
                    selectedItem={selectedItem}
                    setSelectedItem={setSelectedItem}
                  />
                )}
              </div>
            </div>
          )}
        </div>
      </header>
    </>
  );
}
